import React from 'react'
import { Routes, Route, Link } from 'react-router-dom'
import Home from './pages/Home'
import NewMatch from './pages/NewMatch'
import LiveScore from './pages/LiveScore'
import Summary from './pages/Summary'

export default function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="sticky top-0 z-30 bg-gray-900/95 backdrop-blur-md border-b border-gray-800">
        <nav className="max-w-2xl mx-auto p-3 flex items-center justify-between">
          <Link to="/" className="text-lg font-semibold">Gully Scoreboard</Link>
          <div className="flex gap-2">
            <Link to="/new" className="text-sm px-3 py-1 rounded-md bg-gray-800">New</Link>
            <Link to="/live" className="text-sm px-3 py-1 rounded-md bg-gray-800">Live</Link>
          </div>
        </nav>
      </header>


      <main className="flex-1 max-w-2xl w-full mx-auto p-4">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/new" element={<NewMatch />} />
          <Route path="/live" element={<LiveScore />} />
          <Route path="/summary" element={<Summary />} />
        </Routes>
      </main>


      <footer className="text-center text-xs p-3 text-gray-500">Made for gully cricket — mobile-first</footer>
    </div>
  )
}